import React, { useState, useEffect } from 'react';
import { Table, Grid, Autocomplete } from '@mui/material';
import TableBody from '@mui/material/TableBody';
import TableCell from '@mui/material/TableCell';
import TableContainer from '@mui/material/TableContainer';
import TablePagination from '@mui/material/TablePagination';
import TableHead from '@mui/material/TableHead';
import TableRow from '@mui/material/TableRow';
import TableSortLabel from '@mui/material/TableSortLabel';
import Paper from '@mui/material/Paper';
import dayjs from 'dayjs';
import _ from 'lodash';
import Button from '@mui/material/Button';
import Dialog from '@mui/material/Dialog';
import DialogActions from '@mui/material/DialogActions';
import DialogContent from '@mui/material/DialogContent';
import DialogContentText from '@mui/material/DialogContentText';
import DialogTitle from '@mui/material/DialogTitle';
import TextField from '@mui/material/TextField';
import InputLabel from '@mui/material/InputLabel';
import InputAdornment from '@mui/material/InputAdornment';
import FormControl from '@mui/material/FormControl';
import { IconButton } from '@mui/material';
import PeopleOutlineIcon from '@mui/icons-material/PeopleOutline';
import MenuItem from '@mui/material/MenuItem';
import DescriptionIcon from '@mui/icons-material/Description';
import EmailIcon from '@mui/icons-material/EmailOutlined';
import EditIcon from '@mui/icons-material/Edit';
import DeleteIcon from '@mui/icons-material/Delete';
import Checkbox from '@mui/material/Checkbox';
import Swal from 'sweetalert2';
import Select from '@mui/material/Select';
import AddIcCallIcon from '@mui/icons-material/AddIcCall';
import AddHomeIcon from '@mui/icons-material/AddHome';
import AccountCircle from '@mui/icons-material/AccountCircle';
import api from '../../utils/functions/api';
import Typography from '@mui/material/Typography';
import { Controller, useForm } from 'react-hook-form';
import { yupResolver } from '@hookform/resolvers/yup';
import { validateTaxId } from '../../utils/functions/validateTaxId';
import * as yup from 'yup';
import '../../custom.css';
import { swalConfirmAddText, swalErrorBtn, swalErrorTimer, swalSuccessTimer } from '../../helpers/swalHelper';
import ConfigListApi from '../../service/config.api';
import LinearLoading from '../LinearLoading';
import jwtDecode from 'jwt-decode';
import { getStorage } from '../../utils/functions/localstorage';
import BusinessIcon from '@mui/icons-material/Business';

function TableConfigList({
  userList,
  rowsPerPage,
  page,
  total,
  provinces,
  setPage,
  setRowsPerPage,
  sort,
  setSort,
  getConfigList,
  getDistricts,
  getSubdistricts,
  statusETax,
  isLinearLoading,
}) {

  const [open, setOpen] = useState(false);

  const [taxType, setTaxType] = useState('NIDN');
  const [branchID, setBranchID] = useState('');
  const [branchName, setBranchName] = useState('');
  const [customerCode, setCustomerCode] = useState('');

  const [selectedProvince, setSelectedProvince] = useState(null);
  const [districts, setDistricts] = useState([]);
  const [selectedDistrict, setSelectedDistrict] = useState(null);
  const [subdistricts, setSubdistricts] = useState([]);
  const [selectedSubdistrict, setSelectedSubdistrict] = useState(null);
  const [postalCode, setPostalCode] = useState('');

  const [userID, setUserID] = useState('');
  const [openDialogDelete, setOpenDialogDelete] = useState(false);
  const [selectedMerchant, setSelectedMerchant] = useState('');
  const [selectedRows, setSelectedRows] = useState([]);
  const [selectedDeleteUser, setSelectedDeleteUser] = useState(null);

  const decoded = jwtDecode(getStorage('token'));
  const isJV = decoded.IS_JV; 

  const schema = yup.object().shape({
    // tax_id: yup
    //   .string()
    //   .required('กรุณากรอกตัวเลขประจำตัว 13 หลัก')
    //   .matches(/^[0-9]{13}$/, 'กรุณากรอกเลข 13 หลักเท่านั้น')
    //   .test('check-unique-tax-id', 'เลขบัตรไม่ถูกต้อง', async (value) => {
    //     return validateTaxId(value);
    //   }),
    name: yup
      .string()
      .required('กรุณากรอกชื่อผู้ใช้บริการ')
      .matches(/^[^\s]/, 'ตัวแรกต้องไม่ใช่เว้นวรรค')
      .matches(
        /^[ก-๙a-zA-Z0-9\s]+$/,
        'กรอกได้เฉพาะตัวอักษรภาษาไทย ภาษาอังกฤษ และตัวเลขเท่านั้น',
      ),
    phone_number: yup
      .string()
      .required('กรุณากรอกตัวเลข 10 หลัก')
      .matches(/^[0-9]{10}$/, 'กรุณากรอกเบอร์โทร 10 หลักเท่านั้น'),
    one_mail: yup
      .string()
      .required('กรุณากรอก email')
      .test(
        'is-valid-email-list',
        'กรุณากรอกอีเมลในรูปแบบที่ถูกต้อง (สามารถกรอกหลายอีเมลได้โดยใช้จุลภาคคั่น)',
        (value) => {
          if (!value) return true;
          const emails = value.split(',').map((email) => email.trim());
          const emailRegex = /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/;
          return emails.every((email) => emailRegex.test(email));
        },
      ),
    address_detail:
      statusETax &&
      yup
        .string()
        .required('กรุณากรอกที่อยู่')
        .matches(
          /^[^\u{1F600}-\u{1F64F}\u{2702}-\u{27B0}\u{1F680}-\u{1F6FF}\u{1F1E6}-\u{1F1FF}]*$/u,
          'กรุณากรอกที่อยู่ให้ถูกต้อง',
        ),
    selectedProvince:
      statusETax &&
      yup
        .object()
        .shape({
          id: yup.number().required(),
          name_th: yup.string().required(),
        })
        .required('กรุณาเลือกจังหวัด'),
    selectedDistrict:
      statusETax &&
      yup
        .object()
        .shape({
          id: yup.number().required(),
          name_th: yup.string().required(),
        })
        .required('กรุณาเลือกอำเภอ'),
    selectedSubdistrict:
      statusETax &&
      yup
        .object()
        .shape({
          id: yup.number().required(),
          name_th: yup.string().required(),
        })
        .required('กรุณาเลือกตำบล'),
  });
  const {
    register,
    handleSubmit,
    control,
    reset,
    setValue,
    formState: { errors },
  } = useForm({
    resolver: yupResolver(schema),
    defaultValues: {
      tax_id: '',
      name: '',
      phone_number: '',
      one_mail: '',
      address_detail: '',
      selectedProvince: null,
      selectedDistrict: null,
      selectedSubdistrict: null,
    },
  });
  const onSubmit = async (data) => {
    try {
      const {
        address_detail,
        tax_id,
        selectedProvince,
        selectedDistrict,
        selectedSubdistrict,
        postal_code,
      } = data;

      if (taxType === 'TXID' && branchID.length !== 5) {
        return;
      }

      if (isJV) {
        if (branchName === '') {
          return;
        }
      }

      if (customerCode === '' && tax_id === '') {
        swalErrorBtn({title: `กรุณากรอก Customer Code หรือ Tax ID`})
        return;
      }

      //ไว้เช็คค่าว่าง ถ้าว่างใส่null
      const nullAddress = {
        address_detail,
        province: {
          name: selectedProvince?.name_th,
          id: selectedProvince?.id,
        },
        district: {
          name: selectedDistrict?.name_th,
          id: selectedDistrict?.id,
        },
        sub_district: {
          name: selectedSubdistrict?.name_th,
          id: selectedSubdistrict?.id,
        },
        zip_code: postalCode,
      };

      const isAddressValid =
      nullAddress.address_detail &&
      nullAddress.province.id &&
      nullAddress.district.id &&
      nullAddress.sub_district.id &&
      nullAddress.zip_code;

      if (!isAddressValid) {
        // ปิด Dialog เพิ่มลูกหนี้ก่อน
        setOpen(false); // ปิด Dialog

        const confirmResult = await swalConfirmAddText({
          title: 'ยืนยันการดำเนินการ',
          text: 'หากกรอกข้อมูลที่อยู่ไม่ครบถ้วน ระบบจะไม่บันทึกที่อยู่',
          icon: 'warning'
        });

        if (!confirmResult.isConfirmed) {
          setOpen(true); // เปิด Dialog เพิ่มลูกหนี้อีกครั้งถ้าผู้ใช้เลือกยกเลิก
          return;
        }
      }

      //อัพเดท users
      const body = {
        ...data,
        tax_id_type: taxType,
        branch_id: branchID,
        branch_name: branchName,
        customer_code: customerCode,
        tax_id,
        address: !!(selectedDistrict && selectedSubdistrict && postalCode)
          ? nullAddress
          : null,
      }

      const resp = await ConfigListApi.updateDebtor(userID, body);
      // console.log('Response from update user:', resp);
      handleClose();
      swalSuccessTimer({title: 'อัปเดตข้อมูลสำเร็จ'});
      getConfigList();
      return resp;
    } catch (error) {
      Swal.fire(error.message);
      swalErrorTimer({title: 'อัปเดตไม่สำเร็จ', text: error.message, timer: 2000});
      console.error('Error ', error);
    }
  };

  const handleClickOpen = async (row) => {
    // console.log('row', row);
    handleClearFields();
    setUserID(row._id);
    setSelectedMerchant(row);

    setValue('phone_number', row.phone_number);
    setValue('tax_id', row.tax_id);
    setValue('name', row.name);
    setValue('one_mail', row.one_mail);
    setValue('address_detail', row.address?.address_detail || '');

    setValue('selectedProvince', row.address?.province);
    setValue('selectedDistrict', row.address?.district);
    setValue('selectedSubdistrict', row.address?.sub_district);

    setBranchID(row.branch_id || '');
    setBranchName(row.branch_name || '');
    setCustomerCode(row.customer_code || '');
    setTaxType(row.tax_id_type);

    if (row.address?.province) {
      const fixProvice = {
        name_th: row.address.province.name,
        id: row.address.province.id,
      };
      const fixDistrict = {
        name_th: row.address.district.name,
        id: row.address.district.id,
      };
      const fixSubDistrict = {
        name_th: row.address.sub_district.name,
        id: row.address.sub_district.id,
      };

      if (row.address.address_detail && row.address.province.name) {
        setValue('selectedProvince', fixProvice);
        // console.log('🚀 ~ handleClickOpen ~ fixProvice:', fixProvice);
        setValue('selectedDistrict', fixDistrict);
        setValue('selectedSubdistrict', fixSubDistrict);
        setPostalCode(row.address.zip_code);
      }
    }

    setOpen(true);
  };

  const handleClearFields = () => {
    setTaxType('NIDN');
    setBranchID('');
    setBranchName('');
    setCustomerCode('');
    setSelectedProvince(null);
    setSelectedDistrict(null);
    setSelectedSubdistrict(null);
    setPostalCode('');

    reset();
  };

  const handleClose = () => {
    setOpen(false);
  };

  const handleChange = (e) => {
    const selectedTaxType = e.target.value;
    setTaxType(selectedTaxType);

    // เคลียร์ branchID เมื่อเปลี่ยนประเภทผู้เสียภาษีอากรเป็นบุคคลธรรมดาหรืออื่นๆ
    if (selectedTaxType !== 'TXID') {
      setBranchID('');
    }
  };

  const handleBranchIDChange = (e) => {
    const inputBranchID = e.target.value;
    const filteredBranchID = inputBranchID.replace(/[^a-zA-Z0-9]/g, '');
    if (filteredBranchID.length <= 5) {
      setBranchID(filteredBranchID);
    }
  };
  const handleBackspaceBranchID = (e) => {
    if (e.key === 'Backspace' && branchID && branchID.length > 0) {
      setBranchID(branchID.slice(0, -1));
    }
  };

  const handleProvinceChange = async (value) => {
    if (value) {
      setDistricts(await getDistricts(value.id));
      setSelectedProvince(value);
    }
  };

  const handleDistrictChange = async (value) => {
    if (value) {
      setSubdistricts(await getSubdistricts(value.id));
      setSelectedDistrict(value);
    }
  };

  const handleSubdistrictChange = async (value) => {
    if (value) {
      setPostalCode(value.zip_code);
      setValue('zip_code', value.zip_code);
      setSelectedSubdistrict(value);
    }
  };

  const handleOpenDialogDelete = (row) => {
    // console.log(row);
    // เปิด Dialog สำหรับการยืนยันการลบ
    setOpenDialogDelete(true);
    // กำหนดข้อมูลที่จะถูกลบใน State
    setSelectedDeleteUser(row);
  };

  // เส้นลบUser
  const handleIconDeleteClick = async (id) => {
    // Confirmation dialog with SweetAlert2
    const { isConfirmed } = await swalConfirmAddText({title: 'ยืนยันการลบรายการ', text: 'คุณแน่ใจว่าต้องการลบรายการนี้หรือไม่?',icon: 'warning'});

    if (isConfirmed) {
      try {
        await ConfigListApi.deleteDebtorByIdApi(id);

        // Successfully deleted
        swalSuccessTimer({title: 'ลบสำเร็จ', timer: 3000});
        getConfigList(); // Refresh the list of users
      } catch (error) {
        console.error('เกิดข้อผิดพลาด: ', error);
        swalErrorTimer({text: 'ไม่สามารถลบรายการได้, กรุณาลองอีกครั้ง', timer: 3000});
      }
    }
  };
  const handleDeleteSelected = async () => {
    const { isConfirmed } = await swalConfirmAddText({title: 'ยืนยันการลบรายการ', text: 'คุณแน่ใจว่าต้องการลบรายการที่เลือกทั้งหมดหรือไม่?',icon: 'warning'});

    if (isConfirmed) {
      try {
        await ConfigListApi.deleteDebtorByIdApi(selectedRows);

        await swalSuccessTimer({title: 'ลบสำเร็จ', timer: 3000});

        setSelectedRows([]);
        getConfigList();
      } catch (error) {
        await swalErrorTimer({text: 'ไม่สามารถลบรายการได้, กรุณาลองอีกครั้ง', timer: 3000});

        console.error('เกิดข้อผิดพลาด: ', error);
      }
    } else {
      // Cancel message with SweetAlert2
      await swalErrorBtn({title: 'ยกเลิกการลบรายการ'});
    }
  };

  const handleSelectAllRows = (event) => {
    if (event.target.checked) {
      setSelectedRows(userList.map((row) => row._id));
    } else {
      setSelectedRows([]);
    }
  };

  const isSelected = (rowId) => selectedRows.includes(rowId);

  const handleSelectRow = (rowId) => {
    if (isSelected(rowId)) {
      setSelectedRows(selectedRows.filter((id) => id !== rowId));
    } else {
      setSelectedRows([...selectedRows, rowId]);
    }
  };

  // ฟังชั่นยังใช้ไม่ได้ ยังไม่มีเส้น sort by
  const handleSort = (column) => {
    if (sort.column === column) {
      setSort({
        ...sort,
        direction: sort.direction === 'asc' ? 'desc' : 'asc',
      });
      setPage(0);
    } else {
      setSort({ direction: 'asc', column });
      setPage(0);
    }
  };

  // console.log('🚀 ~ selectedMerchant:', selectedMerchant);

  return (
    <div>
      <Dialog
        open={openDialogDelete}
        onClose={() => setOpenDialogDelete(false)}
        aria-labelledby="alert-dialog-title"
        aria-describedby="alert-dialog-description"
        PaperProps={{ style: { minWidth: 'auto', maxWidth: 'auto' } }}
      >
        <DialogTitle id="alert-dialog-title">
          คุณแน่ใจหรือไม่ว่าต้องการลบรายการนี้?
        </DialogTitle>
        <DialogContent>
          <DialogContentText id="alert-dialog-description">
            {selectedDeleteUser && (
              <div>
                <div className="flex justify-start">
                  <div style={{ minWidth: '100px' }}>Name</div>
                  <div> : {selectedDeleteUser.name}</div>
                </div>
                {!!selectedDeleteUser.address.address_detail && (
                  <div className="flex justify-start">
                    <div style={{ minWidth: '100px' }}>Address </div>
                    <Typography>
                      {' '}
                      :
                      {`${selectedDeleteUser.address.address_detail}, ${selectedDeleteUser.address.sub_district.name}, ${selectedDeleteUser.address.district.name}, ${selectedDeleteUser.address.province.name} ${selectedDeleteUser.address.zip_code}`}
                    </Typography>
                  </div>
                )}

                <div className="flex justify-start">
                  <div style={{ minWidth: '100px' }}>Phone No.</div>
                  <div>: {selectedDeleteUser.phone_number}</div>
                </div>
                <div className="flex justify-start">
                  <div style={{ minWidth: '100px' }}>Tax ID</div>
                  <div>: {selectedDeleteUser.tax_id}</div>
                </div>
                <div className="flex justify-start">
                  <div style={{ minWidth: '100px' }}>Email</div>
                  <div>: {selectedDeleteUser.one_mail}</div>
                </div>

                {/* Add other fields as needed */}
              </div>
            )}
          </DialogContentText>
        </DialogContent>
        <DialogActions>
          <Button onClick={() => handleConfirmedDelete(selectedDeleteUser._id)}>
            ใช่
          </Button>
          <Button
            onClick={() => setOpenDialogDelete(false)}
            autoFocus
            color="error"
          >
            ไม่
          </Button>
        </DialogActions>
      </Dialog>
      <Dialog
        open={open}
        onClose={handleClose}
        aria-labelledby="alert-dialog-title"
        aria-describedby="alert-dialog-description"
        PaperProps={{ style: { minWidth: 'auto', maxWidth: 'auto' } }}
      >
        <DialogTitle id="alert-dialog-title">
          <div className="flex">
            <div>{'แก้ไขลูกหนี้'}</div>
          </div>
        </DialogTitle>
        <form onSubmit={handleSubmit(onSubmit)}>
          <DialogContent>
            <DialogContentText id="alert-dialog-description">
              <Grid container spacing={2} sx={{ textAlign: 'start' }}>
                {/* <Grid item xs={12} md={!isJV ? 8 : 12}> */}
                <Grid item xs={12} md={8}>
                  <FormControl fullWidth variant="outlined">
                    <InputLabel id="tax-id-label">
                      ประเภทผู้เสียภาษีอากร
                    </InputLabel>
                    <Select
                      fullWidth
                      labelId="tax-id-label"
                      id="tax-id-select"
                      // {...console.log('👌 taxType', taxType)}
                      value={taxType}
                      label="ประเภทผู้เสียภาษีอากร"
                      onChange={handleChange}
                      startAdornment={
                        <InputAdornment position="start">
                          <PeopleOutlineIcon />
                        </InputAdornment>
                      }
                    >
                      <MenuItem value="TXID">
                        เลขประจำตัวผู้เสียภาษีอากรสำหรับนิติบุคคล
                      </MenuItem>
                      <MenuItem value="NIDN">
                        เลขประจำตัวประชาชน (สำหรับบุคคลธรรมดา)
                      </MenuItem>
                      <MenuItem value="CCPT">
                        เลขหนังสือเดินทาง (Passport)
                      </MenuItem>
                      <MenuItem value="OTHR">อื่นๆ</MenuItem>
                    </Select>
                  </FormControl>
                </Grid>
                {/* <Grid item xs={12} md={!isJV ? 4 : 6}> */}
                <Grid item xs={12} md={4}>
                  <TextField
                    fullWidth
                    value={taxType === 'TXID' ? branchID : ''}
                    id="outlined-basic"
                    label="เลขที่สาขา"
                    placeholder=""
                    disabled={taxType !== 'TXID'}
                    variant="outlined"
                    onChange={handleBranchIDChange}
                    onKeyDown={handleBackspaceBranchID}
                    error={taxType === 'TXID' && branchID.length !== 5}
                    helperText={
                      taxType === 'TXID' && branchID.length !== 5
                        ? 'กรุณากรอกเลขที่สาขาให้ครบ 5 หลัก'
                        : ''
                    }
                    InputProps={{
                      startAdornment: (
                        <InputAdornment position="start">
                          <BusinessIcon/>
                        </InputAdornment>
                      ),
                    }}
                  />
                </Grid>
                {isJV && (
                <Grid item xs={12} md={6}>
                  <TextField
                    fullWidth
                    value={branchName}
                    id="outlined-basic"
                    label="ชื่อสาขา"
                    placeholder=""
                    variant="outlined"
                    onChange={(e) => setBranchName(e.target.value)}
                    error={branchName === '' ? 'กรุณากรอกชื่อสาขา' : ''}
                    helperText={branchName === '' ? 'กรุณากรอกชื่อสาขา' : ''}
                    InputProps={{
                      startAdornment: (
                        <InputAdornment position="start">
                          <BusinessIcon/>
                        </InputAdornment>
                      ),
                    }}
                  />
                </Grid>
                )}
                {isJV && (
                <Grid item xs={12} md={6}>
                  <TextField
                    fullWidth
                    value={customerCode}
                    id="outlined-basic"
                    label="Customer Code"
                    placeholder=""
                    variant="outlined"
                    onChange={(e) => setCustomerCode(e.target.value)}
                    InputProps={{
                      startAdornment: (
                        <InputAdornment position="start">
                          <BusinessIcon/>
                        </InputAdornment>
                      ),
                    }}
                  />
                </Grid>
                )}
                <Grid item xs={12} md={6}>
                  <TextField
                    fullWidth
                    {...register('tax_id')}
                    error={!!errors.tax_id}
                    helperText={errors.tax_id?.message}
                    id="outlined-basic"
                    label="เลขประจำตัวผู้เสียภาษี"
                    variant="outlined"
                    placeholder="กรอกตัวเลข13หลัก"
                    InputProps={{
                      startAdornment: (
                        <InputAdornment position="start">
                          <DescriptionIcon />
                        </InputAdornment>
                      ),
                    }}
                  />
                </Grid>
                <Grid item xs={12} md={6}>
                  <TextField
                    fullWidth
                    {...register('name')}
                    error={!!errors.name}
                    helperText={errors.name?.message}
                    id="outlined-basic"
                    label="ชื่อผู้ใช้บริการ"
                    variant="outlined"
                    InputProps={{
                      startAdornment: (
                        <InputAdornment position="start">
                          <AccountCircle />
                        </InputAdornment>
                      ),
                    }}
                  />
                </Grid>
                <Grid item xs={12} md={6}>
                  <TextField
                    fullWidth
                    {...register('phone_number')}
                    error={!!errors.phone_number}
                    helperText={errors.phone_number?.message}
                    id="outlined-basic"
                    label="หมายเลขโทรศัพท์*"
                    variant="outlined"
                    InputProps={{
                      startAdornment: (
                        <InputAdornment position="start">
                          <AddIcCallIcon />
                        </InputAdornment>
                      ),
                    }}
                  />
                </Grid>
                <Grid item xs={12} md={6}>
                  <TextField
                    fullWidth
                    {...register('one_mail')}
                    error={!!errors.one_mail}
                    helperText={errors.one_mail?.message}
                    id="outlined-basic"
                    label="Email*"
                    variant="outlined"
                    InputProps={{
                      startAdornment: (
                        <InputAdornment position="start">
                          <EmailIcon />
                        </InputAdornment>
                      ),
                    }}
                  />
                </Grid>
                <Grid item xs={12} md={12}>
                  <TextField
                    id="outlined-basic"
                    label="ที่อยู่ เลขที่ / ซอย / ถนน"
                    fullWidth
                    variant="outlined"
                    error={!!errors.address_detail}
                    helperText={
                      errors.address_detail ? errors.address_detail.message : ''
                    }
                    {...register('address_detail')}
                    InputProps={{
                      startAdornment: (
                        <InputAdornment position="start">
                          <AddHomeIcon />
                        </InputAdornment>
                      ),
                    }}
                  />
                </Grid>
                <Grid item xs={12} md={6}>
                  <Controller
                    name="selectedProvince"
                    control={control}
                    render={({ field }) => (
                      <Autocomplete
                        {...field}
                        options={provinces}
                        getOptionLabel={(option) => option.name_th}
                        renderInput={(params) => (
                          <TextField
                            {...params}
                            label="จังหวัด"
                            error={!!errors.selectedProvince}
                            helperText={errors.selectedProvince?.message}
                          />
                        )}
                        onChange={(_, value) => {
                          field.onChange(value);
                          handleProvinceChange(value);
                        }}
                        isOptionEqualToValue={(option, value) =>
                          option.id === value?.id
                        }
                      />
                    )}
                  />
                </Grid>
                <Grid item xs={12} md={6}>
                  <Controller
                    name="selectedDistrict"
                    control={control}
                    render={({ field }) => (
                      <Autocomplete
                        {...field}
                        options={districts}
                        getOptionLabel={(option) => option.name_th}
                        renderInput={(params) => (
                          <TextField
                            {...params}
                            label="อำเภอ"
                            variant="outlined"
                            error={!!errors.selectedDistrict}
                            helperText={errors.selectedDistrict?.message}
                          />
                        )}
                        onChange={(_, value) => {
                          field.onChange(value);
                          handleDistrictChange(value);
                        }}
                        isOptionEqualToValue={(option, value) =>
                          option.id === value?.id
                        }
                      />
                    )}
                  />
                </Grid>
                <Grid item xs={12} md={6}>
                  <Controller
                    name="selectedSubdistrict"
                    control={control}
                    defaultValue={null}
                    render={({ field }) => (
                      <Autocomplete
                        {...field}
                        options={subdistricts}
                        getOptionLabel={(option) => option.name_th}
                        renderInput={(params) => (
                          <TextField
                            {...params}
                            label="ตำบล"
                            variant="outlined"
                            error={!!errors.selectedSubdistrict}
                            helperText={errors.selectedSubdistrict?.message}
                          />
                        )}
                        onChange={(_, data) => {
                          field.onChange(data);
                          handleSubdistrictChange(data);
                        }}
                        isOptionEqualToValue={(option, value) =>
                          option.id === value?.id
                        }
                      />
                    )}
                  />
                </Grid>
                <Grid item xs={12} md={6}>
                  <TextField
                    fullWidth
                    label="รหัสไปรษณีย์"
                    error={!!errors.postalCode}
                    helperText={
                      errors.postalCode ? errors.postalCode.message : ''
                    }
                    value={postalCode}
                    InputProps={{
                      readOnly: true,
                    }}
                  />
                </Grid>
              </Grid>
            </DialogContentText>
          </DialogContent>
          <DialogActions>
            <Button onClick={handleClose} autoFocus color="error">
              ยกเลิก
            </Button>
            <Button type="submit" variant="outlined">
              ยืนยันการแก้ไข
            </Button>
          </DialogActions>
        </form>
      </Dialog>
      <div className="flex-1">
        <div className="px-2 py-4">
          <TableContainer component={Paper}>
            { <LinearLoading isLinearLoading={isLinearLoading} /> }
            <Table sx={{ minWidth: 650 }} aria-label="simple table">
              <TableHead>
                <TableRow>
                  <TableCell>
                    <Checkbox
                      checked={selectedRows.length === userList.length}
                      onChange={(e) => handleSelectAllRows(e)}
                    />
                  </TableCell>

                  <TableCell>ชื่อ</TableCell>
                  <TableCell>หมายเลขโทรศัพท์</TableCell>
                  <TableCell>เลขประจำตัวผู้เสียภาษี</TableCell>
                  {isJV && (
                    <TableCell>รหัสลูกหนี้</TableCell>
                  )}
                  <TableCell sx={{ width: '15%' }}>
                    <TableSortLabel
                      active={sort.column === 'createdAt'}
                      direction={sort.direction}
                      onClick={() => handleSort('createdAt')}
                    >
                      วันที่อัปโหลด
                    </TableSortLabel>
                  </TableCell>

                  <TableCell>อีเมล</TableCell>

                  <TableCell align="center" sx={{ width: '20%' }}>
                    จัดการรายการ
                  </TableCell>
                </TableRow>
              </TableHead>
              {_.size(userList) ? (
                <TableBody>
                  {userList?.map((row, index) => (
                    <TableRow
                      key={index}
                      sx={{ '&:last-child td, &:last-child th': { border: 0 } }}
                    >
                      <TableCell>
                        <Checkbox
                          checked={isSelected(row._id)}
                          onChange={() => handleSelectRow(row._id)}
                        />
                      </TableCell>

                      <TableCell>{row.name} </TableCell>
                      <TableCell>{row.phone_number}</TableCell>
                      <TableCell>{row.tax_id}</TableCell>
                      {isJV && (
                        <TableCell>{row.customer_code}</TableCell>
                      )}
                      <TableCell>
                        {dayjs(row.createdAt).format('YYYY-MM-DD HH:mm:ss')}
                      </TableCell>
                      <TableCell>{row.one_mail}</TableCell>
                      <TableCell>
                        <div className="flex justify-center">
                          <div>
                            <IconButton onClick={() => handleClickOpen(row)}>
                              <EditIcon color="default" />
                            </IconButton>
                            <IconButton
                              onClick={() => handleIconDeleteClick(row._id)}
                            >
                              <DeleteIcon color="error" />
                            </IconButton>
                          </div>
                        </div>
                      </TableCell>
                    </TableRow>
                  ))}
                </TableBody>
              ) : (
                <TableBody>
                  <TableRow>
                    <TableCell colSpan={8} align="center">
                      <div>ไม่มีข้อมูล</div>
                    </TableCell>
                  </TableRow>
                </TableBody>
              )}
            </Table>
            <TablePagination
              rowsPerPageOptions={[5, 10, 25, 50]}
              component="div"
              rowsPerPage={rowsPerPage}
              page={page}
              count={total}
              onPageChange={(event, newPage) => {
                setPage(newPage);
              }}
              onRowsPerPageChange={(event) => {
                setRowsPerPage(parseInt(event.target.value, 10));
                setPage(0);
              }}
            />
          </TableContainer>
        </div>
      </div>
      <div align="right">
        <Button
          variant="contained"
          color="error"
          onClick={handleDeleteSelected}
        >
          ลบทั้งหมด {selectedRows.length} รายการ
        </Button>
      </div>
    </div>
  );
}

export default TableConfigList;
